import { RouteConfig } from "vue-router";

export const appAccounts: RouteConfig[] = [
  {
    // 設置アプリアカウント管理
    path: "app-accounts/:groupId",
    component: () => import("@/pages/AppAccounts/_Tab.vue"),
    children: [
      {
        path: "",
        name: "app-accounts-list",
        component: () => import("@/pages/AppAccounts/AppAccountsList.vue")
      },
      {
        path: "new",
        name: "app-accounts-new",
        component: () => import("@/pages/AppAccounts/AppAccountsNew.vue")
      }
    ]
  },
  {
    // 設置アプリアカウント管理
    path: "app-accounts/:groupId/:appUserId",
    component: () => import("@/pages/AppAccount/_Tab.vue"),
    children: [
      {
        path: "",
        name: "app-account-details",
        component: () => import("@/pages/AppAccount/AppAccountDetails.vue")
      },
      {
        path: "rooms",
        name: "app-account-rooms",
        component: () => import("@/pages/AppAccount/AppAccountRooms.vue")
      },
      {
        path: "invite",
        name: "app-account-invite",
        component: () => import("@/pages/AppAccount/AppAccountInvite.vue")
      }
    ]
  }
];
